import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	alertingSectionHeading: {
		id: 'servicedesk-incident-management-settings.responder-alerts.alerting-section-heading',
		defaultMessage: 'Responder alerts',
		description:
			'Heading of the settings section which controls e.g. whether responder alerts are sent',
	},
	alertingSectionDescription: {
		id: 'servicedesk-incident-management-settings.responder-alerts.alerting-section-description',
		defaultMessage:
			'Responder alerts will automatically be created when someone is assigned, added as responder or owns a service. Enabling responder alerts will only affect new incidents.',
		description:
			'Description text, explaining what will change if user changes "shouldSendResponderAlerts" toggle value',
	},
	responderAlertLearnMoreLink: {
		id: 'servicedesk-incident-management-settings.responder-alerts.responder-alert-learn-more-link',
		defaultMessage: 'Learn more about responder alerts.',
		description: "link to the public atlassian docs about responder alerts and when they're sent",
	},
	alertingSectionToggleLabel: {
		id: 'servicedesk-incident-management-settings.responder-alerts.alerting-section-toggle-label',
		defaultMessage: 'Responder alerts',
		description: 'Label for the "shouldSendResponderAlerts" when toggle is on',
	},
	manageAlertPriorityHeading: {
		id: 'servicedesk-incident-management-settings.responder-alerts.manage-alert-priority-heading',
		defaultMessage: 'Alert priorities',
		description: 'Heading for the sub-section, which allows to edit alert priority mapping',
	},
	manageAlertPriorityDescription: {
		id: 'servicedesk-incident-management-settings.responder-alerts.manage-alert-priority-description',
		defaultMessage:
			'Jira admins can control the level of alerts sent for incidents by assigning alert priorities to incident priorities. This will affect all service projects using incident management.',
		description: 'Description which gives user details about editinig alert priority mapping',
	},
	manageAlertPriorityLearnMoreLink: {
		id: 'servicedesk-incident-management-settings.responder-alerts.manage-alert-priority-learn-more-link',
		defaultMessage: 'Learn more about alert priorities.',
		description: 'Link to public atlassian docs on how to edit the priority mappings',
	},
	assignAlertPriorityButtonText: {
		id: 'servicedesk-incident-management-settings.responder-alerts.assign-alert-priority-button-text',
		defaultMessage: 'Assign alert priorities',
		description: 'Assign alert priorities mappings text',
	},
});
